import { useEffect, useState } from "react";
import { defer } from "rxjs";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { getUser } from "../services/userService";
import { bulkGet } from "../services/bulkServices";

export const useGetUser = (id) => {
  const [user, setUser] = useState(null);

  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (!id) {
      return;
    }

    const fetchData = async (id) => {
      try {
        const token = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });

        const user = await getUser(id, token.idToken);
        const appSettingsRes = await bulkGet(
          {
            collection: "Settings",
            filter: {
              id: "app-settings"
            },
            project: {
              _id: 0,
              id: 0
            },
            confirm: true
          },
          token.idToken
        );

        let appSettings = null;

        if (appSettingsRes.status === 200) {
          appSettings = appSettingsRes?.response[0] ?? {};
        }

        return { user, appSettings, auth: token };
      } catch (e) {
        return { user: null, appSettings: null, auth: null, logout: true };
      }
    };

    const subscription = defer(() => fetchData(id)).subscribe(setUser);

    return () => {
      subscription.unsubscribe();
    };
  }, [id, instance, accounts]);

  return user;
};
